/*
 * Created Date: 23-01-2023, 11:14:05 am
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { endOfToday, startOfDay, subDays } from 'date-fns'
import moment from 'moment'

export const getLast7DayParams = () => {
	const today = new Date()
	const start_date = moment(startOfDay(subDays(today, 6))).format('YYYY-MM-DD HH:mm:ss')
	const end_date = moment(endOfToday()).format('YYYY-MM-DD HH:mm:ss')
	return { start_date, end_date }
}

export const formatTime = timer => {
	const getSeconds = Math.floor(timer % 60) // `0${timer % 60}`.slice(-2)
	const minutes = `${Math.floor(timer / 60)}`
	const getMinutes = `0${minutes % 60}`.slice(-2)
	const getHours = `0${Math.floor(timer / 3600)}`.slice(-2)

	return `${getHours} : ${getMinutes} : ${getSeconds}`
}

export const renderTime = timer => {
	if (timer <= 0) {
		return 0
	}
	const getSeconds = timer < 60 ? timer.toFixed(0) : `0${timer % 60}`.slice(-2)
	const minutes = `${Math.floor(timer / 60)}`
	const getMinutes = `0${minutes % 60}`.slice(-2)
	const getHours = `0${Math.floor(timer / 3600)}`.slice(-2)

	return `${getHours !== '00' ? `${getHours} giờ` : ''} ${getMinutes !== '00' ? `${getMinutes} phút` : ''} ${
		getSeconds !== '00' ? `${getSeconds} giây` : ''
	}`
}

export const timeAgoSeconds = item => {
	let seconds
	if (item.next_show_time) {
		seconds = Math.floor(new Date(`${item.next_show_time}Z`) - new Date()) / 1000
	} else {
		seconds = Math.floor(new Date(`${item.updated_at}`) - new Date()) / 1000
	}

	return seconds
}
